import { useState, useCallback, useMemo } from 'react'

type UseStepperReturn = {
  steps: string[]
  currentStep: number
  next: () => void
  prev: () => void
  goToStep: (step: number) => void
  isFirst: boolean
  isLast: boolean
}

function useStepper(steps: string[], initialStep = 0): UseStepperReturn {
  const [currentStep, setCurrentStep] = useState(initialStep)

  const next = useCallback(() => {
    setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1))
  }, [steps.length])

  const prev = useCallback(() => {
    setCurrentStep((prev) => Math.max(prev - 1, 0))
  }, [])

  const goToStep = useCallback(
    (step: number) => {
      if (step >= 0 && step < steps.length) {
        setCurrentStep(step)
      }
    },
    [steps.length]
  )

  const isFirst = currentStep === 0
  const isLast = currentStep === steps.length - 1

  return useMemo(
    () => ({ steps, currentStep, next, prev, goToStep, isFirst, isLast }),
    [steps, currentStep, next, prev, goToStep, isFirst, isLast]
  )
}

export default useStepper
export type { UseStepperReturn }
